import axios from "axios";
import _ from "lodash";
import { Notification } from 'element-ui'

const state = {};

const mutations = {};

const actions = {
  async list(context, params) {
    try {
      const { data } = await axios.get("/company", {
        params
      });

      return data
    } catch (err) {
      Notification({
        type: 'error',
        title: 'Erro de carregamento',
        message: _.get(
          err,
          "response.message",
          "Não foi possível carregar as empresas"
        ),
        duration: 6000,
      });
    }
  },


  async update(context, { id, company }) {
    try {
      const { data } = await axios.put("/company/" + id, company);

      return data;
    } catch (err) {
      Notification({
        type: 'error',
        title: 'Erro ao atualizar',
        message: _.get(
          err,
          "response.message",
          "Não foi possível atualizar a empresa"
        ),
        duration: 6000,
      });
    }
  },

  async create(context, company) {
    try {
      const { data } = await axios.post("/company", company);

      return data;
    } catch (err) {
      Notification({
        type: 'error',
        title: 'Erro ao criar',
        message: _.get(
          err,
          "response.data.error",
          "Não foi possível criar a empresa"
        ),
        duration: 6000,
      });
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
